/**
 * @generated SignedSource<<6116c1530b83499ae95fc9befce2185d>>
 * @relayHash df563f8f73740e1ca9fbb14d2a121fa8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5c64c8808078c6ecf2ef82d8e201245d748a72ae8df2ef7e6d030b99e9b1c025

import type { ConcreteRequest } from 'relay-runtime';
export type GoalCapabilitiesQuery$variables = {
  containerId: string;
  isM3GroupPermsEnabled: boolean;
};
export type GoalCapabilitiesQuery$data = {
  readonly goals_capabilities?: {
    readonly canCreateGoal: boolean | null;
    readonly canCreateUpdates: boolean | null;
    readonly canExportGoals: boolean | null;
  } | null;
};
export type GoalCapabilitiesQuery = {
  response: GoalCapabilitiesQuery$data;
  variables: GoalCapabilitiesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "containerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isM3GroupPermsEnabled"
  }
],
v1 = [
  {
    "condition": "isM3GroupPermsEnabled",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "containerId",
            "variableName": "containerId"
          }
        ],
        "concreteType": "TownsquareGoalAppCapabilities",
        "kind": "LinkedField",
        "name": "goals_capabilities",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "canCreateGoal"
          },
          {
            "kind": "ScalarField",
            "name": "canCreateUpdates"
          },
          {
            "kind": "ScalarField",
            "name": "canExportGoals"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GoalCapabilitiesQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GoalCapabilitiesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "5c64c8808078c6ecf2ef82d8e201245d748a72ae8df2ef7e6d030b99e9b1c025",
    "metadata": {},
    "name": "GoalCapabilitiesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1bb62e948fddce1deb8be731d3f1197d";

export default node;
